import ApiService from "../../common/api.service";
import Vue from "vue";

const state = {
  all: [],
  cache: {}
};

// getters
const getters = {
  getParticipant: state => id => {
    return state.all[state.cache[id]];
  },
  getAll: state => {
    return state.all;
  }
};

// actions
const actions = {
  addParticipant(context, participant) {
    return new Promise((resolve, reject) => {
      ApiService.post("/participants", participant)
        .then(response => {
          context.commit("ADD", response.data);
          context.dispatch("loadParticipants");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateParticipant(context, participant) {
    return new Promise((resolve, reject) => {
      ApiService.put("/participants/" + participant.id, participant)
        .then(response => {
          context.commit("UPDATE", response.data);
          context.dispatch("loadParticipants");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadParticipants(context) {
    ApiService.get("/participants").then(response => {
      context.commit("SET", response.data);
    });
  },
  delete(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.delete("/participants/" + item.id)
        .then(() => {
          context.commit("DEL", item);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  export() {
    return new Promise(resolve => {
      ApiService.query("/export", { params: { type: "participant" } }).then(
        response => {
          resolve(response);
        }
      );
    });
  }
};

// mutations
const mutations = {
  ADD(state, item) {
    state.all.push(item);
    state.cache[item.id] = state.all.length - 1;
  },
  SET(state, items) {
    state.all = items;
    createCache(items);
  },
  UPDATE(state, item) {
    const index = state.cache[item.id];
    Vue.set(state.all, index, item);
  },
  DEL(state, item) {
    state.all.splice(state.cache[item.id], 1);
  }
};

function createCache(participants) {
  for (let i = 0; i < participants.length; i++) {
    state.cache[participants[i].id] = i;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
